import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'luggageUnit'
})
export class LuggageUnitPipe implements PipeTransform {

    public transform(unit?: string): string {
        if (unit === undefined) {
            return null;
        }
        switch (unit.toLowerCase()) {
            //TODO: find units enum
            case 'kilogram':
                return 'kg';
            default:
                return null;
        }
    }
}
